/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Warehouse_TitleInputs */

const vi_dashboard_warehouse_title = /** @type {(inputs: Dashboard_Warehouse_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng điều khiển kho`)
};

/**

* @param {Dashboard_Warehouse_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_warehouse_title = /** @type {((inputs?: Dashboard_Warehouse_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Warehouse_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_warehouse_title(inputs)
});